export const data = {
  author: {
    type: "author",
    heading: "How can I promote my book?",
    description: "My book is published. What do I do next?",
    buttonText: "Find your Readers",
    middleText: "Why work with us?",
    color: "bg-yellow-600",
    perks: [
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 5.375C4.11111 5.375 0.500003 8.21875 0.500003 9.4375C0.500003 10.6563 4.11111 13.5 7 13.5C9.88889 13.5 13.5 10.6563 13.5 9.4375C13.5 8.21875 9.88889 5.375 7 5.375ZM7 5.375V0.500003M10.9 6.1875L13.5 2.63281M3.1 6.1875L0.500003 2.63281"
              stroke="#D99B07"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M9.5 9.5C9.5 10.8807 8.38071 12 7 12C5.61929 12 4.5 10.8807 4.5 9.5C4.5 8.11929 5.61929 7 7 7C8.38071 7 9.5 8.11929 9.5 9.5Z"
              stroke="#D99B07"
            />
          </svg>
        ),
        description: "Get your book discovered by eager readers",
      },
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <mask id="path-1-inside-1" fill="white">
              <path d="M7.00002 0C4.2386 0 2.00002 2.1069 2.00002 4.70588C2.00002 5.87367 2.45197 6.9421 3.20023 7.76471L6.44177 11.3778C6.73981 11.71 7.26024 11.71 7.55828 11.3778L10.7998 7.76471C11.5481 6.9421 12 5.87367 12 4.70588C12 2.1069 9.76145 0 7.00002 0Z" />
            </mask>
            <path
              d="M3.20023 7.76471L3.94459 7.09689L3.93997 7.09182L3.20023 7.76471ZM6.44177 11.3778L5.69743 12.0456L5.69743 12.0456L6.44177 11.3778ZM10.7998 7.76471L10.0601 7.0918L10.0555 7.0969L10.7998 7.76471ZM7.55828 11.3778L8.30262 12.0456L8.30262 12.0456L7.55828 11.3778ZM3.00002 4.70588C3.00002 2.71543 4.7329 1 7.00002 1V-1C3.74429 -1 1.00002 1.49836 1.00002 4.70588H3.00002ZM3.93997 7.09182C3.34774 6.44074 3.00002 5.60831 3.00002 4.70588H1.00002C1.00002 6.13903 1.55621 7.44347 2.46049 8.43759L3.93997 7.09182ZM7.18611 10.71L3.94457 7.0969L2.45589 8.43251L5.69743 12.0456L7.18611 10.71ZM13 4.70588C13 1.49836 10.2558 -1 7.00002 -1V1C9.26714 1 11 2.71543 11 4.70588H13ZM11.5396 8.43759C12.4438 7.44347 13 6.13903 13 4.70588H11C11 5.60831 10.6523 6.44074 10.0601 7.09182L11.5396 8.43759ZM8.30262 12.0456L11.5442 8.43251L10.0555 7.0969L6.81394 10.71L8.30262 12.0456ZM5.69743 12.0456C6.39285 12.8207 7.60719 12.8207 8.30262 12.0456L6.81394 10.71C6.91328 10.5992 7.08676 10.5992 7.18611 10.71L5.69743 12.0456Z"
              fill="#D99B07"
              mask="url(#path-1-inside-1)"
            />
            <path
              d="M0.5 13.0005C0.223858 13.0005 0 13.2243 0 13.5005C0 13.7766 0.223858 14.0005 0.5 14.0005V13.0005ZM13.5 14.0005C13.7761 14.0005 14 13.7766 14 13.5005C14 13.2243 13.7761 13.0005 13.5 13.0005V14.0005ZM0.5 14.0005H13.5V13.0005H0.5V14.0005Z"
              fill="#D99B07"
            />
            <mask id="path-4-inside-2" fill="white">
              <path d="M7 8C8.65685 8 10 6.65685 10 5C10 3.34315 8.65685 2 7 2C5.34315 2 4 3.34315 4 5C4 6.65685 5.34315 8 7 8Z" />
            </mask>
            <path
              d="M9 5C9 6.10457 8.10457 7 7 7V9C9.20914 9 11 7.20914 11 5H9ZM7 7C5.89543 7 5 6.10457 5 5H3C3 7.20914 4.79086 9 7 9V7ZM5 5C5 3.89543 5.89543 3 7 3V1C4.79086 1 3 2.79086 3 5H5ZM7 3C8.10457 3 9 3.89543 9 5H11C11 2.79086 9.20914 1 7 1V3Z"
              fill="#D99B07"
              mask="url(#path-4-inside-2)"
            />
          </svg>
        ),
        description: "Send out review copies to the right influencers",
      },
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="1.5"
              y="1.5"
              width="11"
              height="11"
              rx="0.5"
              stroke="#D99B07"
              stroke-linejoin="round"
            />
            <path
              d="M12.5 1.5L11.0157 5.953C10.8131 6.56088 9.99076 6.65116 9.66108 6.1017L8.46744 4.1123C8.11875 3.53114 7.2392 3.67387 7.09218 4.33547L5.9209 9.60624C5.77219 10.2754 4.87769 10.4108 4.53757 9.81565L4.27364 9.35376C3.96174 8.80793 3.15703 8.865 2.92528 9.44938L1.85718 12.1427"
              stroke="#D99B07"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        ),
        description: "Customized strategies and content to promote your book",
      },
    ],
    howItWorks: [
      {
        title: "Schedule a consultation with us today to get started ",
      },
      {
        title:
          "We find your niche social media influencers and organize customized book campaigns on social media",
      },
      {
        title:
          "Watch your book tour the digital space and gather readers along the way",
      },
    ],
    cta: {
      text: "Find your Readers. Join us Today!",
    },
  },
  reviewer: {
    type: "reviewer",
    heading: "How can I connect with Authors?",
    description: "I am a book influencer. How can I discover more good books?",
    buttonText: "Become a Tour Host",
    middleText: "Why join us?",
    color: "bg-green-600",
    perks: [
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.5 6.5C0.223858 6.5 0 6.72386 0 7C0 7.27614 0.223858 7.5 0.5 7.5V6.5ZM3.5 7.5C3.77614 7.5 4 7.27614 4 7C4 6.72386 3.77614 6.5 3.5 6.5V7.5ZM10.5 6.5C10.2239 6.5 10 6.72386 10 7C10 7.27614 10.2239 7.5 10.5 7.5V6.5ZM13.5 7.5C13.7761 7.5 14 7.27614 14 7C14 6.72386 13.7761 6.5 13.5 6.5V7.5ZM7.5 0.5C7.5 0.223858 7.27614 0 7 0C6.72386 0 6.5 0.223858 6.5 0.5H7.5ZM6.5 3.5C6.5 3.77614 6.72386 4 7 4C7.27614 4 7.5 3.77614 7.5 3.5H6.5ZM7.5 10.5C7.5 10.2239 7.27614 10 7 10C6.72386 10 6.5 10.2239 6.5 10.5H7.5ZM6.5 13.5C6.5 13.7761 6.72386 14 7 14C7.27614 14 7.5 13.7761 7.5 13.5H6.5ZM2.75736 2.05026C2.5621 1.855 2.24551 1.855 2.05025 2.05026C1.85499 2.24552 1.85499 2.5621 2.05025 2.75736L2.75736 2.05026ZM4.17157 4.87869C4.36684 5.07395 4.68342 5.07395 4.87868 4.87869C5.07394 4.68342 5.07394 4.36684 4.87868 4.17158L4.17157 4.87869ZM9.82843 9.12133C9.63316 8.92606 9.31658 8.92606 9.12132 9.12133C8.92606 9.31659 8.92606 9.63317 9.12132 9.82843L9.82843 9.12133ZM11.2426 11.9498C11.4379 12.145 11.7545 12.145 11.9497 11.9498C12.145 11.7545 12.145 11.4379 11.9497 11.2426L11.2426 11.9498ZM11.9497 2.75736C12.145 2.5621 12.145 2.24552 11.9497 2.05026C11.7545 1.855 11.4379 1.855 11.2426 2.05026L11.9497 2.75736ZM9.12132 4.17158C8.92606 4.36684 8.92606 4.68342 9.12132 4.87869C9.31658 5.07395 9.63316 5.07395 9.82843 4.87869L9.12132 4.17158ZM4.87868 9.82843C5.07394 9.63317 5.07394 9.31659 4.87868 9.12132C4.68342 8.92606 4.36683 8.92606 4.17157 9.12132L4.87868 9.82843ZM2.05025 11.2426C1.85499 11.4379 1.85499 11.7545 2.05025 11.9498C2.24551 12.145 2.5621 12.145 2.75736 11.9498L2.05025 11.2426ZM0.5 7.5H3.5V6.5H0.5V7.5ZM10.5 7.5H13.5V6.5H10.5V7.5ZM6.5 0.5V3.5H7.5V0.5H6.5ZM6.5 10.5V13.5H7.5V10.5H6.5ZM2.05025 2.75736L4.17157 4.87869L4.87868 4.17158L2.75736 2.05026L2.05025 2.75736ZM9.12132 9.82843L11.2426 11.9498L11.9497 11.2426L9.82843 9.12133L9.12132 9.82843ZM11.2426 2.05026L9.12132 4.17158L9.82843 4.87869L11.9497 2.75736L11.2426 2.05026ZM4.17157 9.12132L2.05025 11.2426L2.75736 11.9498L4.87868 9.82843L4.17157 9.12132Z"
              fill="#1EBB45"
            />
          </svg>
        ),
        description: "Receive plenty of ARCs and free books",
      },
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="7" cy="7" r="6.5" stroke="#1EBB45" />
            <circle cx="7" cy="7" r="2.5" stroke="#1EBB45" />
            <path
              d="M3.5 2.5C3.5 3.05228 3.05228 3.5 2.5 3.5C1.94772 3.5 1.5 3.05228 1.5 2.5C1.5 1.94772 1.94772 1.5 2.5 1.5C3.05228 1.5 3.5 1.94772 3.5 2.5Z"
              fill="white"
              stroke="#1EBB45"
            />
          </svg>
        ),
        description: "Never run out of content as a Book Pundit Influencer",
      },
      {
        icon: (
          <svg
            width="50"
            height="50"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.91667 5.33333C1.58198 5.33333 0.5 4.25135 0.5 2.91667C0.5 1.58198 1.58198 0.5 2.91667 0.5C4.25135 0.5 5.33333 1.58198 5.33333 2.91667C5.33333 3.30614 5.24157 3.67274 5.07894 3.99737C4.68157 4.79057 3.86205 5.33333 2.91667 5.33333Z"
              stroke="#1EBB45"
              stroke-linejoin="round"
            />
            <path
              d="M11.0833 8.83333C9.7486 8.83333 8.66663 7.75135 8.66663 6.41667C8.66663 5.08198 9.7486 4 11.0833 4C12.418 4 13.5 5.08198 13.5 6.41667C13.5 6.80614 13.4082 7.17274 13.2456 7.49737C12.8482 8.29057 12.0287 8.83333 11.0833 8.83333Z"
              stroke="#1EBB45"
              stroke-linejoin="round"
            />
            <path
              d="M2.91667 13.4998C1.58198 13.4998 0.5 12.4179 0.5 11.0832C0.5 9.74848 1.58198 8.6665 2.91667 8.6665C4.25135 8.6665 5.33333 9.74848 5.33333 11.0832C5.33333 11.4726 5.24157 11.8392 5.07894 12.1639C4.68157 12.9571 3.86205 13.4998 2.91667 13.4998Z"
              stroke="#1EBB45"
              stroke-linejoin="round"
            />
            <path
              d="M5.25 9.91683L8.75 7.5835M8.75 5.25016L5.25 4.0835"
              stroke="#1EBB45"
            />
          </svg>
        ),
        description: "Grow your followers and reader network",
      },
    ],
    howItWorks: [
      {
        title:
          "Register with us as an influencer to receive updates on active and upcoming book tours",
        description:
          "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
      },
      {
        title:
          "On being selected as a book tour host, you will receive the book. Enjoy reading the book",
        description:
          "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
      },
      {
        title:
          "Share your authentic review or content for the book and get paid at the end of the tour",
        description:
          "Amet minim mollit non deserunt ullamco est sit aliqua dolor do amet sint. Velit officia consequat duis enim velit mollit. Exercitation veniam consequat sunt nostrud amet.",
      },
    ],
    cta: {
      text: "Find your Readers. Join us Today!",
    },
  },
};
